import { useEffect } from 'react';
import type { ReactNode } from 'react';

export interface ValidationControllerProps {
  children?: ReactNode;
  errorElementId?: string;
  hasValidationError: boolean;
}

export default function ValidationController({
  children,
  errorElementId,
  hasValidationError,
}: ValidationControllerProps) {
  useEffect(() => {
    const errorElement = document.getElementById(errorElementId || 'validation-error');
    if (hasValidationError && errorElement) {
      errorElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => {
        errorElement?.focus();
      }, 400);
    }
  }, [errorElementId, hasValidationError]);

  return <>{children}</>;
}
